import {Observable} from "rxjs";
import {AjaxResponse} from "rxjs/ajax";
import {IUserState} from "lib/reducers/user.slice";
import {ApiRoutes} from "lib/services/api.routes";
import {IUpdateUserProfileResponse} from "./interfaces/update-user-profile.interface";
import {TYPES} from "lib/ioc/ioc.types";
import {WindowContainer} from "lib/interfaces/user.interface";
import {INewApiService} from "lib/services/api/api.interface";

export default class ProfileService {
  _apiService: INewApiService;

  /**
   *
   */
  constructor(user: IUserState) {
    const container = WindowContainer.GetWindow().di_container;
    const api = container.get<INewApiService>(TYPES.ApiService);
    this._apiService = api;
  }

  UpdateUserProfile(UserId: number, UserType: number, ProfilePart: string, ProfileInfo: string): Observable<AjaxResponse<IUpdateUserProfileResponse>> {
    return this._apiService.post({
      url: ApiRoutes.Profile.UpdateUserProfile,
      params: {
        UserId,
        UserType,
        ProfilePart,
        ProfileInfo
      },
      data: {}
    });
  }

  IsUsernameAvailable(Username: string): Observable<AjaxResponse<boolean>> {
    return this._apiService.get({
      url: ApiRoutes.Profile.IsUsernameAvailable,
      params: {
        Username
      },
    });
  }

  IsEmailAvailable(email: string): Observable<AjaxResponse<boolean>> {
    return this._apiService.get({
      url: ApiRoutes.Profile.IsEmailAvailable,
      params: {
        email
      }
    });
  }

  UpdateLanguage(ParticipantId: number, CultureID: number) {
    return this._apiService.post({
      url: ApiRoutes.Profile.UpdateLanguage,
      params: {
        ParticipantId,
        CultureID
      },
      data: {}
    });
  }

  GetUserCertifications(UserId: number) {
    return this._apiService.get({
      url: ApiRoutes.Profile.GetUserCertifications,
      params: {
        UserId
      },
    })
  }


}
